<template>
  <div class="wrapper">
    <div class="page">
      <div class="header">
        <div class="logo">
          <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
        </div>
      </div>

      <div class="main-content2">
        <img
          class="sad-face"
          src="@/assets/images/sad-face-icon.svg"
          alt="sad-face"
        />

        <div class="card">
          <p class="main-title">Sorry, link expired.</p>

          <template v-if="$route.name == 'complianceLinkExpired'">
            <p class="sub-title">
              {{ getExpiryMsg }}
            </p>
            <b-button variant="primary" class="main-btn activ-btn">
              <router-link
                :to="{ name: 'dashboard', query: { expectedVisit: true } }"
                ><img
                  class="smaller-than-icon"
                  src="@/assets/images/smaller-than.svg"
                  alt="Arrow-icon"
                />BACK TO PASSPORT</router-link
              >
            </b-button>
          </template>

          <template v-else>
            <p class="sub-title">
              Your one time login link has expired because you used it to login
              once before. Click the button below to login or request a new
              link.
            </p>
            <b-button variant="primary" class="main-btn activ-btn">
              <router-link :to="{ name: 'login' }"
                ><img
                  class="smaller-than-icon"
                  src="@/assets/images/smaller-than.svg"
                  alt="Arrow-icon"
                />BACK TO LOGIN</router-link
              >
            </b-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("compliance", ["getExpiryMsg"]),
  },
};
</script>

<style lang="scss" scoped>
.with-header-included {
  display: none;
}
.sad-face {
  position: absolute;
  z-index: 1;
  margin-top: -310px;
  width: 78px;
  height: 78px;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  align-content: center;
  .page {
    display: flex;

    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #e5e5e5;
    .header {
      .logo {
        display: block;
        width: 116px;
        height: 22px;
        margin: 59px 0 0 59px;
      }
    }

    .main-content2 {
      height: 90vh;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
      align-items: center;
      .card {
        width: 661px;
        height: 292px;
        background: #ffffff;
        box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
        border-radius: 26px;
        margin-bottom: 0px !important;
        display: flex;
        align-items: center;
        .main-title {
          font-weight: 700;
          font-size: 20px;
          line-height: 24px;
          text-align: center;
          color: #000000;
          margin-top: 72px;
          margin-bottom: 23px;
        }
        .sub-title {
          font-weight: 400;
          font-size: 17px;
          line-height: 134.5%;
          text-align: center;
          color: #787878;
          margin-bottom: 0px !important;
          width: 548px;
        }
      }
    }
  }
}
.main-btn {
  display: block;
  width: 415px;
  height: 44px !important;
  margin-top: 47px;
  margin-bottom: 37px;

  border-radius: 22px;
  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  text-align: center;
  color: #fff;
  border: none;
  a {
    color: #fff;
  }
}
.smaller-than-icon {
  margin: 0 9px 2px 0;
}
@media (max-width: 992px) {
  .wrapper {
    background: #e5e5e5;
    .page {
      background: #ffffff;
      width: 390px;
      height: 100%;
      .header .logo {
        display: block;
        width: 116px;
        height: 22px;
        margin: 73px auto 0 auto !important;
      }
    }
  }

  .main-content2 {
    margin-top: 198px !important;
    margin-bottom: 276px !important;
  }

  .card {
    // background: yellow;
    width: 350px !important;
    // height: 274px;

    background: #f2f2f2 !important;
    border-radius: 17px !important;
    p.main-title {
      font-family: "Lato";
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      text-align: center;
      color: #000000;
      margin-bottom: 19px !important;
    }
    p.sub-title {
      font-family: "Lato";
      font-style: normal;
      font-weight: 400 !important;
      font-size: 14px !important;
      line-height: 20px !important;
      width: 289px !important;
      text-align: center !important;
      letter-spacing: 0.25px !important;
      color: #666666 !important;
    }
    .main-btn {
      display: block;
      width: 309px !important;
      height: 37px !important;
      margin-top: 25px !important;
      margin-bottom: 32px !important;
      border-radius: 18.5px !important;
      font-weight: 500 !important;
      font-size: 16px !important;
      line-height: 17px !important;
      text-align: center;
      letter-spacing: 0.25px;
      text-transform: uppercase;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
}
</style>